/*
  GoRoam — legal page helper (loaded by blocks/gr-legal.liquid).
  Builds the "On this page" list from the Heading 2s in the page content, gives each heading
  an id so the links work, and highlights the heading currently on screen.
*/
document.querySelectorAll('[data-gr-legal]').forEach((root) => {
  const toc = root.querySelector('[data-gr-toc]');
  const prose = root.querySelector('[data-gr-prose]');
  if (!toc || !prose) return;
  const heads = [...prose.querySelectorAll('h2')];
  if (!heads.length) { toc.previousElementSibling?.remove(); toc.remove(); return; }
  const used = new Set();
  const slug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
  const links = heads.map((h, i) => {
    if (!h.id) { let id = slug(h.textContent); while (used.has(id)) id += '-' + i; h.id = id; }
    used.add(h.id);
    const a = document.createElement('a');
    a.href = '#' + h.id; a.textContent = h.textContent.trim();
    if (i === 0) a.setAttribute('aria-current', 'true');
    toc.appendChild(a);
    return a;
  });
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      links.forEach((a) => a.removeAttribute('aria-current'));
      links[heads.indexOf(e.target)].setAttribute('aria-current', 'true');
    });
  }, { rootMargin: '-10% 0px -70% 0px' });
  heads.forEach((h) => io.observe(h));
});
